/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBallTennis = createReactComponent("outline", "ball-tennis", "IconBallTennis", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6 5.3a9 9 0 0 1 0 13.4", "key": "svg-1" }], ["path", { "d": "M18 5.3a9 9 0 0 0 0 13.4", "key": "svg-2" }]]);

export { IconBallTennis as default };
//# sourceMappingURL=IconBallTennis.mjs.map
